import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import CategoriesSection from '../CategoriesSection'
import GHAnimatedLogo from '../../../../assets/svg/GHAnimatedLogo'
import LayersSearchBox from '../LayersSearchBox'
import SidebarBody from '../../SidebarBody'
import styles from '../LayersContent.module.scss'

function AllLayersTabContent(props) {
  return (
    <>
      <SidebarBody>
        {props.loading ? (
          <div className={styles.ghLoader}>
            <GHAnimatedLogo width={72} height={108} />
            <p>Loading Layers...</p>
          </div>
        ) : (
          <>
            <LayersSearchBox assetsUrl={props.assetsUrl} layers={props.allLayers} dispatch={props.dispatch} />
            {props.eventLayers.length > 0 ? (
              <div className={styles.eventLayerList}>
                <div className={styles.layerListTitle}>
                  <h3>Special Events</h3>
                </div>
                {props.eventLayers.map((eventObj, i) => {
                  return (
                    <CategoriesSection
                      categories={eventObj.categories}
                      isOpen={eventObj.isOpen != null && eventObj.isOpen}
                      key={i}
                      stateName={eventObj.stateName}
                    />
                  )
                })}
              </div>
            ) : null}
            {props.stateLayers.length > 0 ? (
              <div className={styles.stateLayerList}>
                <div className={styles.layerListTitle}>
                  <h3>All States</h3>
                </div>
                {props.stateLayers.map((stateObj, i) => {
                  return (
                    <CategoriesSection
                      categories={stateObj.categories}
                      isOpen={stateObj.isOpen != null && stateObj.isOpen}
                      key={i}
                      stateName={stateObj.stateName}
                    />
                  )
                })}
              </div>
            ) : null}
          </>
        )}
      </SidebarBody>
    </>
  );
}

AllLayersTabContent.propTypes = {
  allLayers: PropTypes.array,
  assetsUrl: PropTypes.string,
  eventLayers: PropTypes.array,
  loading: PropTypes.bool,
  stateLayers: PropTypes.array,
}

export default connect((model) => {
  const { config } = model.app
  const { layersByEvent, layersByState, allLayersLoading } = model.layers
  const allLayers = [...layersByEvent, ...layersByState]
  return {
    assetsUrl: config.GH_ASSETS_CLOUDFRONT_URL,
    allLayers: allLayers,
    eventLayers: layersByEvent,
    loading: allLayersLoading,
    stateLayers: layersByState,
  };
})(AllLayersTabContent);
